module.exports = __webpack_public_path__ + "static/media/calicon.f91fa326.svg";